import { render, staticRenderFns } from "./SchoolTeachers.vue?vue&type=template&id=1d2d0efa&scoped=true&"
import script from "./SchoolTeachers.vue?vue&type=script&lang=js&"
export * from "./SchoolTeachers.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTeachers.vue?vue&type=style&index=0&id=1d2d0efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2d0efa",
  null
  
)

export default component.exports